import { render } from "./BillDetail.vue?vue&type=template&id=37aed6d0&ts=true"
import script from "./BillDetail.vue?vue&type=script&lang=ts"
export * from "./BillDetail.vue?vue&type=script&lang=ts"

import "./BillDetail.vue?vue&type=style&index=0&id=37aed6d0&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__